import React from "react";
// React escapes all strings; no raw HTML or remote image embedding is supported.
function inline(text) {
  return text
    .split(/(\*\*[^*]+\*\*|\*[^*]+\*|_[^_]+_|`[^`]+`)/g)
    .map((part, i) => {
      if (part.startsWith("**") && part.endsWith("**"))
        return <strong key={i}>{part.slice(2, -2)}</strong>;
      if (
        (part.startsWith("*") && part.endsWith("*")) ||
        (part.startsWith("_") && part.endsWith("_"))
      )
        return <em key={i}>{part.slice(1, -1)}</em>;
      if (part.startsWith("`") && part.endsWith("`"))
        return <code key={i}>{part.slice(1, -1)}</code>;
      return part;
    });
}
export default function MessageMarkdown({ text }) {
  return (
    <div className="message-markdown">
      {String(text || "")
        .split(/\n\s*\n/)
        .map((p, i) => (
          <p key={i}>{inline(p)}</p>
        ))}
    </div>
  );
}
